import { createContext, useContext, type ReactNode } from 'react';

import { fetchCommentsGateway } from '../api/fetchCommentsGateway';
import type { CommentsGateway } from '../ports/commentsGateway';

/**
 * Which backend the comment hooks talk to. It defaults to the real one, so the
 * app mounts no provider; a test mounts one holding an in-memory gateway.
 */
const CommentsGatewayContext = createContext<CommentsGateway>(fetchCommentsGateway);

export function CommentsGatewayProvider({
  gateway,
  children,
}: {
  gateway: CommentsGateway;
  children: ReactNode;
}) {
  return (
    <CommentsGatewayContext.Provider value={gateway}>{children}</CommentsGatewayContext.Provider>
  );
}

export function useCommentsGateway() {
  return useContext(CommentsGatewayContext);
}
